import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login, loading, error, clearError, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const [form, setForm] = useState({ identifier: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [formError, setFormError] = useState('');

  useEffect(() => {
    if (user) navigate(from, { replace: true });
  }, [user, navigate, from]);

  useEffect(() => {
    clearError();
  }, []); // eslint-disable-line

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setFormError('');
  };

  const validate = () => {
    const id = form.identifier.trim();
    if (!id) return 'Email or mobile number is required.';
    const isEmail = id.includes('@');
    const isMobile = /^\+?[0-9]{10,15}$/.test(id);
    if (!isEmail && !isMobile) return 'Enter a valid email address or mobile number.';
    if (!form.password) return 'Password is required.';
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    if (err) { setFormError(err); return; }
    try {
      await login(form.identifier.trim(), form.password);
      navigate(from, { replace: true });
    } catch {
      // error shown via context
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <span className="auth-icon">🔮</span>
          <h1>Welcome Back</h1>
          <p>Sign in to continue your cosmic journey</p>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          {(formError || error) && (
            <div className="auth-error">
              <span>⚠️</span> {formError || error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="identifier">Email or Mobile Number</label>
            <input
              id="identifier"
              name="identifier"
              type="text"
              autoComplete="username"
              placeholder="your@email.com or 9876543210"
              value={form.identifier}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="auth-input-wrapper">
              <input
                id="password"
                name="password"
                type={showPassword ? 'text' : 'password'}
              autoComplete="off"
                placeholder="Enter your password"
                value={form.password}
                onChange={handleChange}
                disabled={loading}
              />
              <button
                type="button"
                className="auth-toggle-pw"
                onClick={() => setShowPassword(v => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary auth-submit"
            disabled={loading}
          >
            {loading ? <span className="auth-spinner" /> : 'Sign In ✨'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Don't have an account?{' '}
            <Link to="/signup" className="auth-link">Create one</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
